export interface DocumentStatusType {
    [x: string]: string,
}

const documentConfig = {
    status: {
        PENDING: 'Pending',
        REVIEWING: 'Reviewing',
        READY: 'Ready',
        PUBLISHED: 'Published',
        IN_REVIEW: 'Reviewing',
        PROCESSING: 'Pending'
    },
    defaultVersion: 1
}

export {
    documentConfig
}
